export const askDostEn = {
  ask_dost: `Ask Dost`,
  good_greeting: `Good {{greeting}}`,
  morning: `morning`,
  afternoon: `afternoon`,
  evening: `evening`,
  "how_can_i_help_you_today?": `How can I help you today?`,
  new_ai_chat: `New AI Chat`,
  unable_to_clear_chat: `Unable to clear chat history`,
  unable_to_send_confirmation: `Unable to send confirmation`,
  thinking: `Thinking`,
  thought_process: `Thought process`,
  running_tool: `Running {{tool}}...`,
  tool_completed: `{{tool}} completed`,
  tool_failed: `{{tool}} failed`,
  confirmation_required: `Confirmation required`,
  approve: `Approve`,
  reject: `Reject`,
  accept: `Accept`,
  approved: `{{confirmTool}} created - view it in the {{confirmTool}} page`,
  rejected: `{{confirmTool}} cancelled`,
  attach_file: `Attach file`,
  unable_to_upload_file: `Unable to upload {{fileName}}`,
  invalid_file_type: `{{fileName}} is not a supported file type. Allowed types are PDF, CSV, and XLSX`,
  duplicate_file: `{{fileName}} has already been added`,
  upload_limit_exceeded: `Unable to upload the document due to the size limit exceed`,
  too_many_files_error: `Too many files in this conversation. Start a new conversation to attach more.`,
  list_vendors: `List Vendors`,
  get_input_mappings: `Get Input Mappings`,
  get_documents: `Get Documents`,
  new_chat: `New Chat`,
  expand: `Expand`,
  collapse: `Collapse`,
  close: `Close`,
  copy: `Copy`,
  copied: `Copied!`,
  regenerate: `Regenerate`,
  show_less: `Show less`,
  show_more: `Show more`,
  something_went_wrong: `Something went wrong`,
  count_documents: `Count documents`,
  cancel: `Cancel`,
  send_message: `Send message`,
  there: `there`,
  quick_action_documents: {
    label: `Documents`,
    prompt_1: `Show me all invoices pending review`,
    prompt_2: `Which documents failed to post to the ERP?`,
    prompt_3: `Show me all invoices received this week and their status`,
    prompt_4: `Find all documents with discrepancies`,
    prompt_5: `Export the latest processed invoice from [supplier name]`,
  },

  quick_action_mappings: {
    label: `Mappings`,
    prompt_1: `Show me all active input mappings`,
    prompt_2: `I want to create a new mapping, help me set it up`,
    prompt_3: `Walk me through creating a mapping for a new supplier`,
    prompt_4: `Help me set up a mapping rule for a specific document type`,
    prompt_5: `How do I upload bulk mappings?`,
  },

  quick_action_workflows: {
    label: `Workflows`,
    prompt_1: `Show me all pending approval workflows`,
    prompt_2: `Create an approval workflow for invoices over €10,000`,
    prompt_3: `Which invoices are waiting for approval right now?`,
    prompt_4: `I want to create a new approval workflow, where do I start?`,
    prompt_5: `What workflows do we currently have active?`,
  },

  quick_action_analytics: {
    label: `Analytics`,
    prompt_1: `Give me a summary report of today's document activity.`,
    prompt_2: `Give me a chart of how many documents are pending review right now.`,
    prompt_3: `Give me a chart showing which suppliers sent the most invoices this month.`,
    prompt_4: `Give me a chart showing how many documents failed this week.`,
    prompt_5: `Help me forecast`,
  },
  edit_instructions: `Edit instructions`,
  prompts: `Prompts`,
  no_further_action_required_mapping: `This mapping is no longer available. Please create a new workflow from Ask Dost.`,
  no_further_action_required_workflow: `This workflow is no longer available. Please create a new workflow from Ask Dost.`,
  proposal_failed: `This proposal failed to execute.`,
  proposal_expired: `That proposal is no longer pending — it may already have been decided.`,
  only_pdf_csv_excel_files_accepted: `Only PDF (max 25MB) and CSV/Excel (max 10MB) files are accepted, with a maximum of 15 files total.`,
  upload: `Upload`,
  browse_files: `Browse Files`,
  upload_your_documents: `Upload your documents`,
  drag_and_drop_your_files_here: `Drag and Drop your files here`,
  files_accepted_only: `{{acceptedFiles}} files accepted only`,
  upload_and_manage_support_documents: `Upload and manage support documents`,
  upload_files_for_ask_dost: `Upload Files for Ask Dost`,
  you_can_attach_files_in_your_prompts_to_ask_dost_for_it_to_analyse_them: `You can attach files in your prompts to Ask Dost for it to analyse them`,
  characters_used: `characters used`,
  offline_error: `You're offline. Please check your internet connection and try again.`,
  back_online: `You're back online.`,

  // Preferences popover (mode + saved prompts tabs)
  preferences: `Preferences`,
  mode: `Mode`,
  saved_prompts: `Saved Prompts`,
  answering_mode: `Answering Mode`,
  mode_fast_name: `Fast`,
  mode_fast_desc: `Direct answers on your live data. Best for status checks and lookups.`,
  mode_thinking_name: `Thinking`,
  mode_thinking_desc: `Unlocks deep thinking — plans across more steps before answering. Best for mappings, workflows and reconciliation.`,
  thinking_mode_badge: `Thinking mode`,
  thinking_mode_on_notice: `Thinking mode on — Dost plans across more steps before answering.`,

  // Model switch popover
  model: `Model`,
  model_auto_name: `Auto`,
  model_auto: `Auto`,
  model_strong: `Strong`,
  model_minimal: `Minimal`,
  model_recommended: `Recommended`,
  model_auto_desc: `Dost picks the right model for each request`,
  model_strong_desc: `Deepest reasoning — complex analysis`,
  model_recommended_desc: `Balanced (default)`,
  model_minimal_desc: `Fastest — for simple, basic tasks only`,
  model_haiku_desc: `Fastest — status lookups, single-document questions.`,
  model_sonnet_desc: `Balanced default — mappings, workflows, table and chart answers.`,
  model_opus_desc: `Deepest reasoning — reconciliation, multi-step analysis across many documents.`,

  // History dropdown / full-screen side panel
  chat_history: `Chat history`,
  hide_history: `Hide history`,
  recent_chats: `Recent`,
  history_search_placeholder: `Search chats`,
  history_no_match: `No chats match "{{query}}"`,
  new_chat_title: `New chat`,
  chat_n: `Chat {{id}}`,
  chat_deleted_successfully: "Chat deleted successfully",
  unable_to_delete_chat: "Unable to delete chat",
  rename: `Rename`,
  delete: `Delete`,
  rename_conversation: `Rename chat`,
  chat_renamed_successfully: "Chat renamed successfully",
  unable_to_rename_chat: "Unable to rename chat",

  // Dictation
  dictate: `Dictate`,
  done: `Done`,
  listening: `Listening…`,
  paused: `Paused`,
  pause: `Pause`,
  resume: `Resume`,

  // Mapping / workflow flow diagram card
  execution_order: `Execution order #{{n}}`,
  condition_n: `Condition {{n}}`,
  need_changes: `Need changes`,
  create: `Create`,
  previous: `Previous`,
  next: `Next`,
  page_of: `{{current}} of {{total}}`,
  draft_n_of_total: `Draft {{current}} of {{total}}`,
  always: `ALWAYS`,
  mapping_action_kicker: `MAPPING ACTION`,
  approval_action_kicker: `APPROVAL ACTION`,
  and_connector: `AND`,
  then_connector: `THEN`,
  action_set_prefix: `Set`,
  action_to_infix: `to`,
  conditions_kicker: `Conditions`,
  applied: `Applied`,
  none_applies_to_every_document: `None — applies to every document`,
  mapping_rule_fallback: `Mapping Rule`,
  applies_to_incoming_documents: `Applies to incoming documents`,
  rule_fallback: `Rule`,
  field_fallback: `Field`,
  set_direct_action: `Set value`,
  formula_action: `Formula`,
  map_action: `Map`,
  unknown_target_fallback: `Unknown`,

  // Code / file / referenced docs blocks
  show_all_lines: `Show all {{count}} lines`,
  download: `Download`,
  downloading: `Downloading...`,
  documents_referenced: `Documents referenced`,
  unable_to_list_too_many_documents: `Unable to list as too many documents were referenced`,
  output: `Output`,
  processing: `Processing`,
  executing_code: `Executing code`,
  code_executed: `Code executed`,
  loading: `Loading...`,
  NeedApproval: `Approval required`,
  Approved: `Approved`,
  Rejected: `Rejected`,
  NoApprovalRequired: `No approval required`,
  execution_complete: `Execution complete`,
  sandbox_fallback: `sandbox`,

  // Saved prompts
  save_prompt: `Save prompt`,
  saved_to_prompts: `Saved to prompts`,
  all: `All`,
  saved_by_you: `Saved by you`,
  dost_suggestions: `Dost Suggestion`,
  no_saved_prompts_yet: `No saved prompts yet. Tap the bookmark under a message you sent to save it here.`,
  remove_saved_prompt: `Remove saved prompt`,
  prompt_saved: `Prompt saved successfully`,
  prompt_deleted: `Prompt removed successfully`,
  unable_to_save_prompt: `Unable to save prompt`,
  unable_to_delete_prompt: `Unable to delete prompt`,

  // Memories
  memories: `Memories`,
  saved_by_dost: `Context saved by Ask Dost so it can answer you better in future conversations`,
  clear_all: `Clear`,
  confirm_delete_message: `Are you sure you want to delete this?`,
  delete_conversation_title: `Are you sure you want to delete this chat?`,
  delete_conversation_message: `You will no longer be able to access prompts and responses within this chat.`,
  delete_memory_title: `Are you sure you want to remove memory?`,
  delete_memory_message: `This note will be removed from Ask Dost's memory and this cannot be undone.`,
  delete_prompt_title: `Are you sure you want to remove prompt?`,
  delete_prompt_message: `Once a prompt is removed you can no longer quickly access it from saved prompts menu.`,
  clear_all_memories_title: `Are you sure you want to clear the memory?`,
  clear_all_memories_message: `Clearing memory wipes out all the context Ask Dost has saved so far about you to use across chats.`,
  no_memories_yet: 'No memories yet. Memories are saved by Ask Dost to help it answer you better in future conversations.',
  delete_memory: `Delete memory`,
  no_statement_available: `No statement available`,
  last_seen: `Last seen: {{date}}`,
  memory_deleted: `Memory deleted`,
  unable_to_delete_memory: `Unable to delete memory`,
  memories_cleared: `Memories cleared`,
  unable_to_clear_memories: `Unable to clear memories`,

  // Integrations tab (mocked — UI only, no real ERP connection yet)
  connectors: `Connectors`,
  erp_connections: `ERP Connections`,
  connect: `Connect`,
  connecting: `Connecting…`,
  sync_now: `Sync now`,
  syncing: `Syncing…`,
  disconnect: `Disconnect`,
  connected: `Connected`,
  not_connected: `Not connected`,
  connect_your_odoo_app: `Connect your Odoo Accounting app`,
  last_synced: `Last synced {{when}}`,
  just_now: `just now`,
  more_erp_connectors_coming: `More ERP connectors are on the way. Ask Dost reads and posts documents through the connected app.`,
  data_synced: `Data Synced`,
  synced_entity_vendors: `Vendors`,
  synced_entity_customers: `Customers`,
  synced_entity_invoices: `Invoices`,
  synced_entity_bills: `Bills`,
  synced_entity_products: `Products`,
  synced_entity_purchase_orders: `Purchase Orders`,
  connect_odoo: `Connect Odoo`,
  odoo_connect_subtitle: `Use an API key where possible — it can be revoked without changing the account password.`,
  odoo_url: `Odoo URL`,
  odoo_url_required: `Odoo URL is required`,
  invalid_url: `Invalid URL`,
  username: `Username`,
  api_key_or_password: `API key or password`,
  invalid_api_key_or_password: `Invalid API key or password`,
  api_key_required: `API key or password is required`,
  database_name_optional: `Database name (optional)`,
  odoo_connect_validation_error: `Fill in the URL, username and API key or password.`,
  erp_connection_failed: `ERP connection failed`,
  erp_synced_successfully: `ERP synced successfully`,
  erp_sync_failed: `ERP sync failed`,
  erp_disconnected: `ERP disconnected`,
  erp_disconnect_failed: `ERP disconnect failed`,
  disconnect_confirm_title: `Are you sure you want to disconnect?`,
  disconnect_confirm_message: `Once disconnected you won't be able to access this ERP's data.`,
  connecting_to_erp_title: `Connecting to your ERP`,
  connecting_to_erp_subtitle: `Ask Dost is pulling your Odoo records. This can take a minute on large databases.`,
  syncing_with_odoo_title: `Syncing with Odoo`,
  syncing_with_odoo_subtitle: `Bringing your Odoo records up to date.`,
  retry: `Retry`,
  sync_failed_message: `Failed to sync — Odoo did not return this data. Ask Dost will answer without it.`,
  "odoo_missing_po_model_error": `This Odoo has no purchase.order model — the app that provides it is not installed, so this dataset is not available here.`,
  preview: `Preview`,
  vendors: "Vendors",
  customers: "Customers",
  invoices: "Invoices",
  bills: "Bills",
  products: "Products",


  // Thinking block
  understanding_your_query: `Understanding your query`,
  no_conversations_found: `No conversations found`,
  ask_dost_greeting: `Hey {{firstName}}, how can I help you today?`,
  ask_about_documents: `Ask about documents, mappings, workflows or spend. Saved prompts sit under the preferences icon.`,
  ask_dost_placeholder: `Ask Dost...`,
};
